import { BorderBox } from "@/components/atoms/BorderBox";

export function NoOptionsForm() {
    return (
        <BorderBox variant='info' size='sm'>
            This field does not require any options.
        </BorderBox>
    )
}